import { attunedApi } from 'services/index';
import { CHECK_COUPON, REMOVE_COUPON } from 'constants/actionTypes';

export const checkCouponSuccess = (couponResponse) => ({
    type: CHECK_COUPON,
    couponResponse,
});

export const removeCoupon = () => ({
    type: REMOVE_COUPON,
});


export const checkCoupon = (couponCode) => {
    const url = '/coupon';
    return dispatch => {
        return attunedApi.post(url, `${ couponCode }`).then(response => dispatch(checkCouponSuccess(response)))
            .catch(error => {
                throw (error);
            });
    };
};
